import { useTranslate } from "@refinedev/core";
import Textarea from "@uiw/react-md-editor/lib/components/TextArea/Textarea";
import {
  Form,
  Input,
  Row,
  Col,
} from "antd";
import TextArea from "antd/es/input/TextArea";

export const FormList = ({ }: any) => {
  const t = useTranslate();

  return (
    <Row gutter={[64, 0]} wrap>
      <Col xs={24} lg={8}>
        <Form.Item
          label={"Service"}
          name="service"
          rules={[
            {
              required: true,
              message: "Service is required!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"Description"}
          name="description"
          rules={[
            {
              required: true,
              message: "Description is required!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={"API Key"}
          name="apiKey"
          rules={[
            {
              required: true,
              message: "API key is required!",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>
    </Row >
  );
};
